import { defineComponent as _defineComponent } from 'vue'
import { toRefs, computed } from 'vue';
  import type { PropType } from 'vue';

  type iconPositionType = 'left' | 'right';

  //eslint-disable-next-line
  
export default /*#__PURE__*/_defineComponent({
  __name: 'AppButton',
  props: {
    iconComponent: {
      type: Object,
      default: null
    },
    iconPosition: {
      type: String as PropType<iconPositionType>,
      default: 'left'
    },
    iconSize: {
      type: Number,
      default: 24
    },
    rotateIcon: {
      type: Boolean,
      default: false
    }
  },
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

  

  const { iconComponent, iconPosition, iconSize } = toRefs(props);
  const showIcon = computed(() => iconComponent.value != null);

const __returned__ = { props, iconComponent, iconPosition, iconSize, showIcon, toRefs, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})